
import Vue from 'vue'

const component = Vue.extend({})

Vue.component('ALabel', component)
export default component
